import React, { Component } from 'react';
import axios from 'axios';
import { Breadcrumb, Heading } from '../common/atoms';
import { Tabbar } from '../common/molecules';
import { RatingsManager, ContractsManager, WalletUtilizationManager } from '../../managers';
import { utilizationApi } from '../../services';
import { handleAppError } from '../handlers';
import { PharmacyLocked, PharmacyLow } from '../../assets/images';
import { UtilizationLockScreen, NoUtilizationCard } from '../common/organisms';
import { PHARMACY_LOCKED_CONTENT } from '../../constants/utilization';
import {Pharmacy} from '../common/templates/Utilization';
import moment from 'moment';
import DateRangePicker from '../tailwind/molecules/DateRangePicker';
let token = '';

class PharmacyPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      metricObj: {},
      ratingObj: {},
      coverageObj: {},
      walletUtilizationObj: {},
      spentSavingsObj: {},
      benefitName: 'Pharmacy',
      loading: true,
      showNoUtilization: false,
      
      filterDates: {startDate: null, endDate: null}
    };
  }

  fetchCompleteData = (contractId, startDate, endDate) => {
    token = axios.CancelToken.source();
    this.setState({loading: true })
    let start_date = startDate ? startDate : this.state.selectedContractObj.start_date
    let end_date = endDate ? endDate : this.state.selectedContractObj.end_date
    start_date =  moment(start_date).format('YYYY-MM-DD')
    end_date =  moment(end_date).format('YYYY-MM-DD')

    var promise1 = utilizationApi.pharmacyFetchMetrics({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise2 = utilizationApi.pharmacyFetchRatings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise3 = utilizationApi.pharmacyFetchSpendings({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise4 = utilizationApi.pharmacyFetchCoverage({ contractId: contractId, startDate: start_date, endDate: end_date, cancelToken: token.token });
    var promise5 = utilizationApi.walletBenefitUtilization({ contractId, benefit_type : 'pharmacy', startDate: start_date, endDate: end_date })
    
    Promise.all([promise1, promise2, promise3, promise4, promise5])
      .then((values) => {
        var resp_arr = values.map((resp) => resp.data);
        var metricObj = resp_arr[0];
        var ratingObj = new RatingsManager(resp_arr[1]);
        var spentSavingsObj = resp_arr[2];
        var coverageObj = resp_arr[3];
        var showNoUtilization = metricObj.total_orders === 0;
        var walletUtilizationObj = new WalletUtilizationManager(resp_arr[4]);
        walletUtilizationObj.xAxesLabelWallet = 'Months';
        this.setState({ metricObj, ratingObj, coverageObj, spentSavingsObj, loading: false, showNoUtilization, walletUtilizationObj});
      })
      .catch((err) => handleAppError(err));
  };

  fetchContractDetails = () => {
    utilizationApi.fetchContracts(
      {},
      (resp) => {
        var contractObj = new ContractsManager(resp.data, 'PHARMACY');
        this.setState({
          contractObj,
          selectedContractObj: contractObj.formattedData[0],
          contractId: contractObj.formattedData[0].contract_id,
          startDate: contractObj.formattedData[0].start_date,
          endDate: contractObj.formattedData[0].end_date,
          totalCustomers: contractObj.formattedData[0].total_customers,
          filterDates: { startDate: contractObj.formattedData[0]?.start_date, endDate: contractObj.formattedData[0]?.end_date }
        });
      },
      (err) => {
        handleAppError(err);
      }
    );
  };

  componentDidMount() {
    this.fetchContractDetails();
  }

  componentWillUnmount() {
    token && token.cancel();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if ((this.state.contractId && prevState.contractId !== this.state.contractId)|| (this.state.filterDates.startDate && prevState.filterDates.startDate !== this.state.filterDates.startDate) || (this.state.filterDates.endDate && prevState.filterDates.endDate !== this.state.filterDates.endDate)) {
      token && token.cancel();
      this.fetchCompleteData(this.state.contractId, this.state.filterDates.startDate, this.state.filterDates.endDate);
    }
  }

  toggleHelp = () => this.props.toggleHelp('Pharmacy');

  content = (selectedContractObj) => {
    const { loading, showNoUtilization } = this.state;

    if (loading || selectedContractObj.enable_pharmacy) {
      return showNoUtilization ? (
        <NoUtilizationCard
          line='utilization of pharmacy including prescription and OTC medication'
          imgsrc={PharmacyLow}
          toggleHelp={this.toggleHelp}
          classes='mt-8'
        />
      ) : (
        <Pharmacy {...this.state} />
      );
    } else {
      return (
        <div className='mt-8'>
          <UtilizationLockScreen
            sectionTitle='Pharmacy is not enabled'
            image={PharmacyLocked}
            sectionSubtitle='Benefits to your employees'
            points={PHARMACY_LOCKED_CONTENT}
            toggleHelp={this.toggleHelp}
          />
        </div>
      );
    }
  };

  changeContractId = (contract) => {
    const { contractId } = this.state;
    const { contract_id, start_date, end_date } = contract;
    if (contract_id && contractId !== contract_id) {
      this.setState({
        contractId: contract_id,
        startDate: start_date,
        endDate: end_date,
        selectedContractObj: contract,
        metricObj: {},
        ratingObj: {},
        walletUtilizationObj: {},
        coverageObj: {},
        loading: true,
        showNoUtilization: false,
        filterDates: {startDate: contract?.start_date, endDate: contract?.end_date}
      });
    }
  };

  changeDates = (e, date_type) =>{
    let date = moment(e).format('YYYY-MM-DD')
    if (e){
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: date}})
      }
      else if(date_type === 'endDate') {
        this.setState({filterDates: {...this.state.filterDates, endDate: date}})
      }
      else if(date_type === 'reset'){
        this.setState({filterDates: {startDate: moment(this.state.selectedContractObj?.start_date)}, endDate: moment(this.state.selectedContractObj?.end_date)})
      }
    }
    else{
      if (date_type === 'startDate'){
        this.setState({filterDates: {...this.state.filterDates, startDate: moment(this.state.selectedContractObj.start_date).format('YYYY-MM-DD')}})
      }
      else {
        this.setState({filterDates: {...this.state.filterDates, endDate: moment(this.state.selectedContractObj.end_date).format('YYYY-MM-DD')}})
      }
    }
  };

  render() {
    const { contractObj, loading } = this.state;
    const formattedData = contractObj ? contractObj.formattedData : null;

    return (
      <React.Fragment>
        <Breadcrumb
          list={[
            { text: 'Utilization', link: '/utilization/ahc' },
            { text: 'Pharmacy', link: '/pharmacy' },
          ]}
          classes='mb-1'
        />
        {typeof this.state.selectedContractObj !== 'undefined' && (
          <Heading
            mainHeading='Utilization of Pharmacy'
          />
        )}
        <div className='flex justify-start mt-5 m-0'>
          <div className='tracking-widest font-semibold text-xs text-gray-500'>
            CONTRACT PERIOD/YEAR
          </div>
        </div>
        <Tabbar
          list={formattedData}
          loading={loading}
          currentPage={formattedData ? formattedData[0].text : null}
          setContract={this.changeContractId}
        />
        {contractObj && <DateRangePicker filterDates={this.state.filterDates}
                                         contractDates={[this.state.selectedContractObj?.start_date, this.state.selectedContractObj?.end_date]} 
                                         changeDates={this.changeDates}/>}
        {this.content(this.state.selectedContractObj)}
      </React.Fragment>
    );
  }
}

export default PharmacyPage;
